import { BaseResponseAttributes } from "../attributes/base-attributes";
import { RestApiResponse } from "./RestApi";
import BaseService from "./BaseService";
import { InviteEmployeeAttributes } from "../attributes/branch-manager-attributes";

export class GeneralSettingService extends BaseService {
  static async getGeneralSettings(): Promise<
    RestApiResponse<BaseResponseAttributes>
  > {
    return GeneralSettingService.getApiClient().get(`general-settings/get`);
  }

  static async setGeneralSettings(
    data: any[]
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return GeneralSettingService.getApiClient().post(
      `general-settings/set`,
      data
    );
  }

  static getAllbusinesses(): Promise<RestApiResponse<BaseResponseAttributes>> {
    return GeneralSettingService.getApiClient().get(`admin/businesses`);
  }
}

export default GeneralSettingService;
